import Spacer from '@berlitz/spacer'
import ImageTrophyCelebrateAllLevelsSimple from '@berlitzplatforms/micro.image.trophy-celebrate-all-levels-simple'
import NotificationCard from '@berlitzplatforms/micro.ui.notification-card'
import FormattedHTMLMessage from '@components/FormattedHTMLMessage'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { AllLevelsNotifContent, AllLevelsNotifHeader, AllLevelsNotifSubHeader } from './style'

const AllLevelsNotifMessage = ({ lp, isOnDemand }) => (
  <>
    <AllLevelsNotifHeader>
      <FormattedMessage id="Congratulations!" defaultMessage="Congratulations!" />
    </AllLevelsNotifHeader>
    <Spacer size="xxs" />
    <Spacer size="xxxs" />
    <AllLevelsNotifSubHeader>
      <FormattedHTMLMessage id="You've completed {lp}!" defaultMessage="You've completed {lp}!" values={{ lp }} />
    </AllLevelsNotifSubHeader>
    <AllLevelsNotifContent>
      {isOnDemand ? (
        <FormattedMessage
          id="Keep practicing by redoing learning activities until your course end date, or explore more Berlitz courses."
          defaultMessage="Keep practicing by redoing learning activities until your course end date, or explore more Berlitz courses."
        />
      ) : (
        <FormattedMessage
          id="You now have unlimited coaching sessions until your course end date."
          defaultMessage="You now have unlimited coaching sessions until your course end date."
        />
      )}
    </AllLevelsNotifContent>
  </>
)

const AllLevelsNoficationCard: React.FC<{ lp?: string; isOnDemand?: boolean }> = ({ lp = '', isOnDemand = false }) => {
  const intl = useIntl()

  const viewOtherCourses = () => {
    const url = intl.formatMessage({
      id: 'view-other-courses-link',
      defaultMessage: 'https://www.berlitz.com',
    })
    window.open(url, '_blank')
  }

  return (
    <>
      <NotificationCard
        image={<ImageTrophyCelebrateAllLevelsSimple />}
        maxWidth="594px"
        message={
          <AllLevelsNotifMessage
            lp={`<span style="color:#004fef;font-weight:500">${lp}</span>`}
            isOnDemand={isOnDemand}
          />
        }
        onButtonClick={() => viewOtherCourses()}
        buttonLabel={intl.formatMessage({ id: 'View other courses', defaultMessage: 'View other courses' })}
      ></NotificationCard>
    </>
  )
}

export default AllLevelsNoficationCard
